import React from 'react'

import Field from '@utilities/Field'
import FieldContainer from './FieldContainer'

interface ITextareaProps {
  /** Max char count */
  maxlength: number
}

class TextareaField extends Field<ITextareaProps> {
  render() {
    const { autoComplete, name, field, info, icon, label, optional, maxlength } = this.props
    let inputClassName = 'Textarea'

    return (
      <FieldContainer field={field} info={info} icon={icon} label={label} optional={optional}>
        <textarea
          maxLength={maxlength}
          autoComplete={autoComplete}
          id={name}
          name={name}
          placeholder={this.props.placeholder}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          className={inputClassName}
          value={field.value || ''}
        />
      </FieldContainer>
    )
  }
}

export default TextareaField
